import { Icon, type IconName } from "~components/ui";
import { CtaItem } from "../cta-item/cta-item";
import { ImageItem } from "../image-item/image-item";
import { SectionBlockHeader } from "../section-block-header/section-block-header";
import { SectionEventsItemDate } from "./section-events-item-date";
import type { AttendanceLowercase, SectionEventsItemProps } from "./types";

function SectionEventsItem({
  blok,
  event,
  ...context
}: Readonly<SectionEventsItemProps>) {
  const image = event.image?.[0];
  const text = event.text?.[0];
  const cta = event.cta?.[0];
  const startDate = new Date(event.startDate);
  const endDate = new Date(event.endDate);
  const locationLabel = blok.location;
  const attendance = event.attendance?.toLowerCase() as AttendanceLowercase;
  const isRemote =
    attendance === "live" ||
    attendance === "online" ||
    attendance === "on demand" ||
    attendance === "remote";
  const icon: IconName = isRemote ? "Globe" : "MapPinLine";
  const label = isRemote ? event.attendance : event.country;

  return (
    <div className="grid h-full grid-rows-[auto_1fr_auto] gap-sm overflow-hidden rounded-sm bg-[white] p-2xs">
      {/* IMAGE */}
      <div className="relative">
        <SectionEventsItemDate startDate={startDate} endDate={endDate} />
        {image.image?.filename && <ImageItem blok={image} {...context} />}
      </div>

      {/* CONTENT */}
      <div className="flex flex-col gap-2xs px-2xs py-3xs">
        <div className="flex items-center gap-3xs text-default-sm leading-none">
          <Icon name={icon} />
          <div>
            {locationLabel && (
              <span className="font-medium text-strong-sm">{`${locationLabel}`}</span>
            )}
            <span>{label}</span>
          </div>
        </div>

        <div className="flex h-full flex-col gap-sm">
          {text && <SectionBlockHeader blok={text} {...context} />}
          {cta && <CtaItem blok={cta} className="mt-auto" {...context} />}
        </div>
      </div>
    </div>
  );
}

export { SectionEventsItem };
